<template>
  <v-col cols="4" class="agenda-date pa-0">
    <p class="agenda-date roxo">
      {{ agendaObject.weekday[0] }}{{ agendaObject.weekday[1]
      }}{{ agendaObject.weekday[2] }}
    </p>
    <div
      v-for="hour in agendaObject.availableHours"
      :key="hour"
      class="agenda-time"
      v-bind:class="statusClasses(hour)"
      @click="$emit('selected', selectedEventObject(hour))"
    >
      <div class="agenda-time-text">{{ hour }}h</div>
    </div>
  </v-col>
</template>

<script>
export default {
  props: {
    agendaObject: {
      type: Object,
      required: true
    },
    selectedDates: Array,
    homeschool: {
      type: Boolean,
      default: false
    },
    removeDates: Array,
    affiliateId: Number,
    subjectId: Number,
    scheduledDates: Array
  },
  data() {
    return {};
  },
  methods: {
    selectedEventObject(hour) {
      let obj = {
        affiliate: this.affiliateId,
        subject: this.subjectId,
        date: `${this.agendaObject.weekdayIndex}-${hour}`,
        homeschool: this.homeschool
      }

      return obj
    },
    statusClasses(hour) {
      return {
        selected:
          (this.selectedDates.some(dateObj => this.checkSelected(dateObj, hour)) || this.scheduledDates.some( dateObj => this.checkSelected(dateObj, hour)) && ! this.removeDates.some( dateObj => this.checkSelected(dateObj, hour))),
          disabled: this.selectedDates.some( dateObj => this.checkDisabled(dateObj, hour)) || this.scheduledDates.some( dateObj => this.checkDisabled(dateObj, hour)),
          removed: this.removeDates.some( dateObj => this.checkSelected(dateObj, hour))
      };
    },
    checkSelected(dateObj, hour) {
      return dateObj.affiliate === this.affiliateId && dateObj.date === `${this.agendaObject.weekdayIndex}-${hour}` && dateObj.subject === this.subjectId && Boolean(dateObj.homeschool) === this.homeschool
    },
    checkDisabled(dateObj, hour) {
      const condition = (dateObj.subject != this.subjectId || dateObj.affiliate != this.affiliateId || this.subjectId && Boolean(dateObj.homeschool) != this.homeschool) && dateObj.date === `${this.agendaObject.weekdayIndex}-${hour}`

      return condition
    }
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:500&display=swap"); */

.agenda {
  padding: 6px;
}
.btn-change-date {
  color: #ffffff;
  line-height: 2;
  font-size: 13px;
}
.agenda-date {
  max-width: 150px;
}
p.agenda-date {
  color: #44ff99;
  font-size: 21px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
}
.agenda-date span {
  font-weight: 400;
  font-style: italic;
  color: #ffffff;
}
.agenda-time {
  height: 70px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 2px 1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(68, 0, 153, 0.2);
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(100, 30, 130, 0.2);
  transition: 0.15s;
}
.agenda-time-text {
  width: 100%;
  text-align: center;
  font-size: 21px;
  font-weight: 500;
  color: rgba(68, 0, 153, 0.5);
}
/* .agenda-time:hover {
  background: rgba(68, 0, 153, 0.8);
}
.agenda-time:active {
  background: rgba(68, 255, 153, 0.9);
} */
.agenda-time.disabled {
  background: rgba(120, 120, 120, 0.5);
}
.agenda-time.selected {
  background: rgba(68, 255, 153, 0.9);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
}

.agenda-time.selected .agenda-time-text {
  color: rgba(68, 0, 153, 1);
}
.agenda-time.disabled div.agenda-time-text {
  color: rgba(50, 50, 50, 0.8);
}
.roxo p.agenda-date.roxo {
  color: #440099;
}
</style>
